const CardsProductosCliente = (props) => {
  console.log("Hola, estos son tus props...", props);
  return <h1>Hola, estás desde el Card</h1>;
};

export default CardsProductosCliente;
